import { encode, decode } from 'cbor-x';
import { Base64 } from 'js-base64';

export const getDataFromLocalStorage = ({ key }: { key: string }): { _id: string; data: any[] } | null => {
    try {
        const lsData = window.localStorage.getItem(key);

        if (!lsData) {
            return null;
        }

        return decode(Base64.toUint8Array(lsData || ''));
    } catch (error) {
        console.error("Can't read from localStorage: ", error);
        throw new Error(String(error));
    }
};

export const putDataIntoLocalStorage = ({ key, data }: { key: string; data: any }): null => {
    const newDoc = {
        _id: key, // fixme: indexDB legacy. Rename it.
        data,
    };

    try {
        const data = Base64.fromUint8Array(new Uint8Array(encode(newDoc)));
        window.localStorage.setItem(key, data);
        return null;
    } catch (error) {
        console.error("Can't put into localStorage: ", error);
        throw new Error(String(error));
    }
};
